import {
    AfterContentInit, ChangeDetectionStrategy,
    Component,
    effect,
    ElementRef,
    inject,
    input,
    InputSignal,
    output,
    OutputEmitterRef,
    Signal,
    viewChild
} from "@angular/core";
import {SelectorType} from "../selector-control/selector";
import {SelectorControlComponent} from "../selector-control/selector-control.component";
import {TranslateModule} from '@ngx-translate/core';
import {ActivatableDirective} from '../../ui-elements/activatable.directive';

@Component({
    selector: "woa-radio-field",
    templateUrl: "./radio-field.component.html",
    styleUrl: "./radio-field.component.scss",
    host: {
        "[class.disabled]": "disabled()"
    },
    imports: [
        SelectorControlComponent,
        TranslateModule,
        ActivatableDirective
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RadioFieldComponent implements AfterContentInit {
    private element: ElementRef = inject(ElementRef);

    public readonly label: InputSignal<string> = input.required<string>();
    public readonly selected: InputSignal<boolean> = input<boolean>(false);

    public readonly message: InputSignal<string> = input<string>();
    public readonly translationParams: InputSignal<Record<string, string | number>> = input<Record<string, string | number>>({});
    public readonly disabled: InputSignal<boolean> = input<boolean>(false);
    public readonly softResizeOnSelect: InputSignal<boolean> = input<boolean>(false);

    public selectedChange: OutputEmitterRef<boolean> = output<boolean>();
    public onActivateLabel: OutputEmitterRef<void> = output<void>();

    public field: Signal<ElementRef> = viewChild.required("field");

    SelectorType = SelectorType;

    private fieldHeight: number = undefined;

    constructor() {
        effect(() => {
            this.selected();
            this.setHeight();
        });
    }

    ngAfterContentInit(): void {
        this.setHeight();
    }

    public setHeight(): void {
        if (this.softResizeOnSelect()) {

            // Set heights back to absolute values immediately so that soft-resize is re-activated
            if (!this.field().nativeElement.scrollHeight) {
                this.fieldHeight = this.field().nativeElement.offsetHeight;
            }
            if (this.fieldHeight !== undefined) {
                this.element.nativeElement.style.maxHeight = this.fieldHeight + 26 + "px";
                this.element.nativeElement.style.minHeight = this.element.nativeElement.style.maxHeight;
            }

            setTimeout(() => {
                if (!this.field().nativeElement.scrollHeight) {
                    this.setHeight();
                    return;
                }

                // Transition requires max and min height to be set to absolute values (can't transition to "fit-content").
                this.fieldHeight = this.field().nativeElement.scrollHeight;
                this.element.nativeElement.style.maxHeight = this.fieldHeight + 26 + "px";
                this.element.nativeElement.style.minHeight = this.element.nativeElement.style.maxHeight;

                // 500 ms later, after the transition has taken place,
                // set the sizes back to fit-content so later changes to the content size are respected (albeit without a transition)
                setTimeout(() => {
                    this.element.nativeElement.style.maxHeight = "fit-content";
                    this.element.nativeElement.style.minHeight = "fit-content";
                }, 500);
            }, 250);
        }
    }
}
